import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MessageContext } from "../../../../common/message";
import { cleanJoin } from "../../../../utils/stringUtil";
import { DELETE } from "../../../../utils/fetchUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { publish } from "../../../../eventBus";

function Quit({ disabled, label, id, uid }) {
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const history = useHistory();
  const { state, dispatch } = useContext(RequestSubmissionContext);

  const quit = () => {
    message.toggle({
      title: t("requests.submission.actions.quitMessageTitle"),
      content: t("requests.submission.actions.quitMessage"),
      onNo: () => message.toggle({}),
      onYes: () =>
        DELETE(
          `/requests/${id}/submissions/${uid}`,
          () => {
                dispatch({ type: "unblock" });
                message.toggle({});
                history.push("/submitRequest");
          },
          (error) => {
            message.toggle({
              title: t("requests.overview.supplement.infoBar.errorTitle"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        ),
    });
  };

  return (
    <button
      disabled={disabled}
      onClick={quit}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-red-1",
        !disabled
          ? "has-background-danger-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
    >
      {label}
    </button>
  );
}

export default Quit;
